import React from "react";
import { FullImageBlock } from "../FullImageBlock/FullImageBlock";
import { ColorPalette } from "../../types/background";

interface HeroBlockProps {
    backgroundImage: string;
    title: string;
    subTitle: string;
    actions: React.ReactNode[];
    videoUrl?: string;
    backgroundColor?: ColorPalette;
    fontColor?: ColorPalette;
}

export const HeroBlock = (props: HeroBlockProps) => <FullImageBlock {...props} type="hero" />;
